export default "__VITE_ASSET__baef6f7c__"